module.exports = __webpack_public_path__ + "static/media/orderEnglish.19bd8cff.gif";